import { __cCreatorCampaignService } from '@/services/client/__c.creator-campaign.service'
import { useQuery } from '@tanstack/react-query'

export const useCreatorCampaignDetail = (slug: string, enabled: boolean) => {
  return useQuery({
    queryKey: ['creator-campaign-detail', slug],
    queryFn: () => __cCreatorCampaignService.getCreatorCampaignDetail(slug),
    enabled: enabled && !!slug,
  })
}
